import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../components/Button';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import { useConfig } from '@lore/config';

InactiveSiteForm.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onPrevious: PropTypes.func,
  activityTypes: PropTypes.object,
  ages: PropTypes.object
};

InactiveSiteForm.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onPrevious: () => {},
};

export default function InactiveSiteForm(props) {
  const {
    alert,
    onPrevious,
    // onSubmit,
    onCancel
  } = props;

  const config = useConfig();

  const learnMoreLink = (
    <a href="https://www.communityshare.org/join/" target="_blank" className="underline hover:text-cs-orange-300">
      Learn more here.
    </a>
  );

  const contactusLink = (
    <span
      className="underline text-cs-orange-500 hover:text-cs-orange-300 cursor-pointer"
      onClick={() => window.Intercom('show')}
    >
      let us know
    </span>
  );

  return (
    <FormTemplate
      title="Looks like this site isn’t active yet."
      onClose={onCancel}
      alert={alert}
      body={(
        <div className="space-y-6">
          <div>
            Projects and events can only be created at active sites.
          </div>
          <div>
            Good news: We’re piloting a program that allows individual schools and organizations to join CommunityShare,
            making it easier than ever to get started.
          </div>
          <ul className="list-disc ml-6">
            <li>
              Want to activate your site? {learnMoreLink}
            </li>
            {config.intercom.enabled && window.Intercom && (
              <li>
                If you believe you’ve received this message in error, please {contactusLink}.
              </li>
            )}
          </ul>
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onPrevious}>
            Back
          </OutlineButton>
          {/*<SolidButton onClick={onSubmit}>*/}
          {/*  Next*/}
          {/*</SolidButton>*/}
        </FormTemplateButtonFooter>
      )}
    />
  );
}
